// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { ISuggestedFaqDetails } from '@/models/suggestedFaq.model';

// Modules
import { StyledChannelTag } from '@/modules/SuggestedFaq';
import { StyledFieldLabel } from '@/modules/SuggestedFaqCommon';

// Components
import {
  StyledConversationLink,
  StyledMetaColumn,
  StyledMetaRow,
  StyledSourceList,
} from './SuggestedFaqMetaInfoStyles';

// Helpers
import { DateFormats } from '@/constants/dates';
import { ROUTES } from '@/constants/routes';
import { getShortId, renderDate } from '@/utils';

type TSuggestedFaqMetaInfoProps = {
  suggestedFaq: Pick<ISuggestedFaqDetails, 'sourceChannels' | 'sources' | 'createdAt'>;
};

const SuggestedFaqMetaInfo: FC<TSuggestedFaqMetaInfoProps> = ({ suggestedFaq }) => {
  const { t } = useTranslation();

  return (
    <StyledMetaRow>
      <StyledMetaColumn>
        <StyledFieldLabel as="span">{t('title_channels')}</StyledFieldLabel>
        <div>
          {suggestedFaq.sourceChannels.map((channel) => (
            <StyledChannelTag key={channel.channelId}>{channel.name || channel.slug}</StyledChannelTag>
          ))}
        </div>
      </StyledMetaColumn>

      <StyledMetaColumn>
        <StyledFieldLabel as="span">{t('column_conversations')}</StyledFieldLabel>
        <StyledSourceList>
          {suggestedFaq.sources.map((source) => (
            <StyledConversationLink key={source.conversationId} to={`${ROUTES.CONVERSATIONS}/${source.conversationId}`}>
              {getShortId(source.conversationId)}
            </StyledConversationLink>
          ))}
        </StyledSourceList>
      </StyledMetaColumn>

      <StyledMetaColumn>
        <StyledFieldLabel as="span">{t('label_created_at')}</StyledFieldLabel>
        <span>{renderDate(suggestedFaq.createdAt, DateFormats.DATE_WITH_TIME)}</span>
      </StyledMetaColumn>
    </StyledMetaRow>
  );
};

export default SuggestedFaqMetaInfo;
